<template>
    <div class="spot">
        <div class="ring"></div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.spot {
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    background-color: $colour__primary1;
}

.ring {
    border: 0.2rem solid $colour__primary1;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    animation: pulse 1.2s ease-out infinite;
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    66% {
        transform: scale(2);
        opacity: 0;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
}
</style>
